module.exports = __webpack_public_path__ + "img/undraw_printing_invoices_5r4r.27064260.svg";